import React from 'react'
import reactyt from '../assets/portfolio/react-yt.png'
import apple from '../assets/portfolio/react-apple1.png'
import crypto from '../assets/portfolio/react-crypto.png'
import weather from '../assets/portfolio/react-weather.png'
import parallax from '../assets/portfolio/parallax.png'
import hiragana from '../assets/portfolio/react-hiragana.png'

const Portfolio = () => {
    const portfolio = [
        {
            id: 1,
            name: "YouTube Clone",
            src: reactyt,
            demoLink: "https://nate-tube.netlify.app/",
            codeLink: "https://github.com/NateNear/react-youtube-clone"
        },
        {
            id: 2,
            name: "iPhone Website",
            src: apple,
            demoLink: "https://apple-clone-lake.vercel.app/",
            codeLink: "https://github.com/NateNear/apple-clone"
        },
        {
            id: 3,
            name: "Cryptotracker Portfolio",
            src: crypto,
            demoLink: "http://cryptracker.s3-website.ap-south-1.amazonaws.com/",
            codeLink: "https://github.com/NateNear/react-cryptracker"
        },
        {
            id: 4,
            name: "Weather app",
            src: weather,
            demoLink: "https://live-weather-status.netlify.app/",
            codeLink: "https://github.com/NateNear/React-Weather-App"
        },
        {
            id: 5,
            name: "Parallax effect",
            src: parallax,
            demoLink: "https://helloparallax.netlify.app/",
            codeLink: "https://github.com/NateNear/Parallax-effect"
        },
        {
            id: 6,
            name: "Hiragana Quiz",
            src: hiragana,
            demoLink: "https://japanese-testquiz.netlify.app/",
            codeLink: "https://github.com/NateNear/react-hiragana"
        }
    ];

    return (
        <div name='portfolio' className='w-full h-full bg-gradient-to-b from-black to-gray-800 text-white md:h-screen'>
            <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
                <div className='pb-8'>
                    <p className='text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-200 text-4xl font-bold inline border-b-4 border-gray-500'>
                        Portfolio
                    </p>
                    <p className='py-6'>Check out some of my work right here</p>
                </div>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:px-0'>
                    {portfolio.map(({ id, name, src, demoLink, codeLink }) => (
                        <div key={id} className='shadow-md shadow-cyan-500 rounded-lg'>
                            <img src={src} alt="" className='rounded-md duration-200 hover:scale-105 w-full h-auto' />
                            <div className='flex items-center justify-center'>
                                <p className='font-bold text-white pt-3 w-full text-center duration-200 hover:scale-105'>{name}</p>
                            </div>
                            <div className='flex justify-between'>
                                <a href={demoLink} target="_blank" rel="noopener noreferrer" className='font-bold text-green-500 w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105'>
                                    Demo
                                </a>
                                <a href={codeLink} target="_blank" rel="noopener noreferrer" className='font-bold text-green-500 w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105'>
                                    Code
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Portfolio;
